import { c as _c } from "react/compiler-runtime";
import { CheckBoxSwitcher, Checkbox, DatePicker, FormInput, FormSelect, Hint } from '@systemeio/ui';
import { getCourseBundleAccessTypeDataOptions } from 'modules/courses/bundles/course-bundle/enums/access-type-enum';
import { AccessTypeEnum } from 'modules/courses/courses/curriculum/enums/access-type-enum';
import { DigitalResourcesTypeEnum, DigitalResourcesTypeTitles } from 'modules/digital-product/enums/digital-resources-type-enum';
import DigitalResourceWrapper from 'modules/digital-product/resources/components/digital-resource-wrapper';
import { DigitalResourceType } from 'modules/digital-product/resources/types/digital-resource-interface';
import { getGrantCourseAccessUrl } from 'modules/digital-product/resources/utils/get-grant-course-access-url';
import { getStaticData } from 'modules/digital-product/resources/utils/get-static-data';
import React, { type JSX } from 'react';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { DigitalProductErrorInterface } from '../../types/digital-product-interface';
import { getCourseAccessTypeDataOptions } from 'modules/courses/courses/curriculum/utils/get-course-access-type-data-options';
import { isPartialType } from 'modules/courses/courses/curriculum/utils/is-partial-type';
export const useDigitalResourceContent = (data, onDelete, errors) => {
  const $ = _c(19);
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  let t0;
  if ($[0] !== data || $[1] !== errors || $[2] !== intlLocale || $[3] !== onDelete || $[4] !== t || $[5] !== user?.createdAt || $[6] !== user?.dashboardLocale || $[7] !== user?.timezone) {
    let t1;
    if ($[9] !== errors || $[10] !== intlLocale || $[11] !== onDelete || $[12] !== t || $[13] !== user?.createdAt || $[14] !== user?.dashboardLocale || $[15] !== user?.timezone) {
      t1 = (resource, idx) => {
        switch (resource.type) {
          case DigitalResourcesTypeEnum.membership_course:
            {
              return <DigitalResourceWrapper resource={resource} onDelete={onDelete ? () => onDelete(resource.id) : undefined} key={resource.id}>{data_5 => <><FormSelect key={`resource-selector-${resource.id}`} data={[{
                    id: DigitalResourcesTypeEnum.membership_course,
                    caption: t(DigitalResourcesTypeTitles[DigitalResourcesTypeEnum.membership_course])
                  }]} disabled={true} value={resource.type} onChange={_temp} /><div className="ml-4 flex flex-col gap-3"><FormSelect key={`course-selector-${resource.id}`} value={resource.course} staticData={getStaticData({
                      id: resource.course,
                      data: data_5.coursesData
                    })} isPreFetching={!data_5.coursesData} data={undefined} onChange={_temp2} disabled={true} error={errors && errors[idx]?.course?.join(", ")} /><FormSelect key={`access-type-selector-${resource.id}`} value={resource.enrollmentAccessType} staticData={getCourseAccessTypeDataOptions(t)} onChange={_temp3} data={undefined} disabled={true} error={errors && errors[idx]?.enrollmentAccessType?.join(", ")} />{isPartialType(resource.enrollmentAccessType) && <div key={`modules-selector-${resource.id}`} className={`flex-col gap-1 text-sm font-medium ${resource.modules && resource.modules.length === 0 ? "hidden" : "flex"}`}><ul className="flex flex-row flex-wrap gap-5">{resource.modules?.map(module => {
                          const label = data_5.courseModulesData?.find(el => el.id === module)?.caption ?? "";
                          return <li key={module}><Checkbox value={true} label={<div className="[&>svg]:fill-brand-primary [&>svg]:main-transition-colors flex items-center gap-1.5">{label}</div>} onChange={_temp4} disabled={true} /></li>;
                        })}</ul></div>}{resource.enrollmentAccessType && !!resource.accessFrom && <><div className="flex min-h-[42px] items-center gap-5" key={`access-from-selector-${resource.id}`}><CheckBoxSwitcher label={<Hint label={<TransLoco t={t} i18nKey="dashboard.funnel.configuration.common.offer_resources.course_start_access_on_day_description" components={{
                          a: <a target="_blank" className="primary-link" href={getGrantCourseAccessUrl(user?.dashboardLocale)} rel="noreferrer" />
                        }} />}>{t("dashboard.funnel.configuration.common.offer_resources.course_start_access_on_day")}</Hint>} selected={resource.accessFrom !== undefined} onChange={_temp5} disabled={true} /><DatePicker value={resource.accessFrom} onChange={_temp6} disabled={true} timezone={user?.timezone} createdAt={user?.createdAt} intlLocale={intlLocale} /></div></>}{(resource.enrollmentAccessType === AccessTypeEnum.fullAccess || isPartialType(resource.enrollmentAccessType)) && !!resource.expirationPeriod && <div className="flex min-h-[42px] items-center gap-5" key={`enrollment-access-type-selector-${resource.id}`}><CheckBoxSwitcher label={<Hint label={t("dashboard.funnel.configuration.common.offer_resources.course_expiration_period_popover")}>{t("dashboard.funnel.configuration.common.offer_resources.course_expiration_period")}</Hint>} selected={!!resource.expirationPeriod} onChange={_temp7} disabled={true} /><FormInput key={`expiration-period-selector-${resource.id}`} value={resource.expirationPeriod} onChange={_temp8} disabled={true} type="number" /></div>}</div></>}</DigitalResourceWrapper>;
            }
          case DigitalResourcesTypeEnum.membership_course_bundle:
            {
              return <DigitalResourceWrapper resource={resource} onDelete={onDelete ? () => onDelete(resource.id) : undefined} key={resource.id}>{data_4 => <><FormSelect key={`resource-type-selector-${resource.id}`} data={[{
                    id: DigitalResourcesTypeEnum.membership_course_bundle,
                    caption: t(DigitalResourcesTypeTitles[DigitalResourcesTypeEnum.membership_course_bundle])
                  }]} disabled={true} value={resource.type} onChange={_temp9} /><div className="ml-4 flex flex-col gap-3"><FormSelect key={`course-bundle-selector-${resource.courseBundle}`} value={resource.courseBundle} staticData={getStaticData({
                      id: resource.courseBundle,
                      data: data_4.courseBundlesData
                    })} isPreFetching={!data_4.courseBundlesData} data={undefined} onChange={_temp10} disabled={true} error={errors && errors[idx]?.courseBundle?.join(", ")} /><>{resource.courseBundle && <FormSelect key={`course-bundle-access-type-selector-${resource.id}`} value={resource.enrollmentAccessType} staticData={getCourseBundleAccessTypeDataOptions(t)} onChange={_temp11} data={undefined} disabled={true} error={errors && errors[idx]?.enrollmentAccessType?.join(", ")} />}{resource.courseBundle && resource.enrollmentAccessType === AccessTypeEnum.drippingContent && <>{resource.enrollmentDrippingAccessCourse ? <FormSelect key={`enrollment-dripping-course-selector-${resource.id}`} value={resource.enrollmentDrippingAccessCourse} staticData={getStaticData({
                          id: resource.enrollmentDrippingAccessCourse,
                          data: data_4.courseBundleCoursesData
                        })} isPreFetching={!data_4.courseBundleCoursesData} data={undefined} onChange={_temp12} disabled={true} error={errors && errors[idx]?.enrollmentDrippingAccessCourse?.join(", ")} /> : <FormInput key={`enrollment-dripping-course-selector-${resource.id}`} value={t("dashboard.funnel.configuration.common.offer_resources.enrollment_dripping_access.first_course")} onChange={_temp13} disabled={true} />}</>}</></div></>}</DigitalResourceWrapper>;
            }
          case DigitalResourcesTypeEnum.systemeio_tag:
            {
              return <DigitalResourceWrapper resource={resource} onDelete={onDelete ? () => onDelete(resource.id) : undefined} key={resource.id}>{data_3 => <><FormSelect data={[{
                    id: DigitalResourcesTypeEnum.systemeio_tag,
                    caption: t(DigitalResourcesTypeTitles[DigitalResourcesTypeEnum.systemeio_tag])
                  }]} disabled={true} value={resource.type} onChange={_temp14} /><FormSelect containerClassName="ml-4" value={Number(resource.value)} data={getStaticData({
                    data: data_3.tagsData,
                    id: resource.value
                  })} isPreFetching={!data_3.tagsData} onChange={_temp15} disabled={true} error={errors && errors[idx]?.value?.join(", ")} /></>}</DigitalResourceWrapper>;
            }
          case DigitalResourcesTypeEnum.community_access:
            {
              return <DigitalResourceWrapper resource={resource} onDelete={onDelete ? () => onDelete(resource.id) : undefined} key={resource.id}>{data_2 => <><FormSelect key={`resource-type-selector-${resource.id}`} data={[{
                    id: DigitalResourcesTypeEnum.community_access,
                    caption: t(DigitalResourcesTypeTitles[DigitalResourcesTypeEnum.community_access])
                  }]} disabled={true} value={resource.type} onChange={_temp16} /><FormSelect key={`campaign-position-input-${resource.id}`} containerClassName="ml-4" value={Number(resource.value)} isPreFetching={!data_2.communitiesData} staticData={getStaticData({
                    data: data_2.communitiesData,
                    id: resource.value
                  })} data={undefined} onChange={_temp17} disabled={true} error={errors && errors[idx]?.value?.join(", ")} /></>}</DigitalResourceWrapper>;
            }
          case DigitalResourcesTypeEnum.systemeio_plan:
            {
              return <DigitalResourceWrapper resource={resource} onDelete={onDelete ? () => onDelete(resource.id) : undefined} key={resource.id}>{data_1 => <><FormSelect key={`resource-type-selector-${resource.id}`} data={[{
                    id: DigitalResourcesTypeEnum.systemeio_plan,
                    caption: t(DigitalResourcesTypeTitles[DigitalResourcesTypeEnum.systemeio_plan])
                  }]} disabled={true} value={resource.type} onChange={_temp18} /><FormSelect key={`systemeio-plan-selector-${resource.id}`} containerClassName="ml-4" value={Number(resource.value)} isPreFetching={!data_1.plansData} staticData={getStaticData({
                    data: data_1.plansData,
                    id: resource.value
                  })} data={undefined} onChange={_temp19} disabled={true} error={errors && errors[idx]?.value?.join(", ")} /></>}</DigitalResourceWrapper>;
            }
          case DigitalResourcesTypeEnum.booking_event:
            {
              return <DigitalResourceWrapper resource={resource} onDelete={onDelete ? () => onDelete(resource.id) : undefined} key={resource.id}>{data_0 => <><FormSelect data={[{
                    id: DigitalResourcesTypeEnum.booking_event,
                    caption: t(DigitalResourcesTypeTitles[DigitalResourcesTypeEnum.booking_event])
                  }]} disabled={true} value={resource.type} onChange={_temp20} /><FormSelect containerClassName="ml-4" value={Number(resource.value)} error={errors && errors[idx]?.value?.join(", ")} data={getStaticData({
                    data: data_0.eventsData,
                    id: resource.value
                  })} isPreFetching={!data_0.eventsData} onChange={_temp21} disabled={true} /></>}</DigitalResourceWrapper>;
            }
          default:
            {
              return <></>;
            }
        }
      };
      $[9] = errors;
      $[10] = intlLocale;
      $[11] = onDelete;
      $[12] = t;
      $[13] = user?.createdAt;
      $[14] = user?.dashboardLocale;
      $[15] = user?.timezone;
      $[16] = t1;
    } else {
      t1 = $[16];
    }
    t0 = data.map(t1);
    $[0] = data;
    $[1] = errors;
    $[2] = intlLocale;
    $[3] = onDelete;
    $[4] = t;
    $[5] = user?.createdAt;
    $[6] = user?.dashboardLocale;
    $[7] = user?.timezone;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  let t1;
  if ($[17] !== t0) {
    t1 = <>{t0}</>;
    $[17] = t0;
    $[18] = t1;
  } else {
    t1 = $[18];
  }
  return t1;
};
function _temp() {}
function _temp2() {}
function _temp3() {}
function _temp4() {}
function _temp5() {}
function _temp6() {}
function _temp7() {}
function _temp8() {}
function _temp9() {}
function _temp10() {}
function _temp11() {}
function _temp12() {}
function _temp13() {}
function _temp14() {}
function _temp15() {}
function _temp16() {}
function _temp17() {}
function _temp18() {}
function _temp19() {}
function _temp20() {}
function _temp21() {}